// src/App.js
import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './context/AuthContext';

// ── Admin Pages ───────────────────────────────────────────────
import Sidebar     from './components/Sidebar';
import Login       from './pages/Login';
import Dashboard   from './pages/Dashboard';
import Orders      from './pages/Orders';
import Users       from './pages/Users';
import WebhookLogs from './pages/WebhookLogs';
import QrScans     from './pages/QrScans';
import PricingManagement from './pages/PricingManagement';

// ── Website Pages ─────────────────────────────────────────────
import HomePage    from './pages/website/HomePage';
import AboutPage   from './pages/website/AboutPage';
import PricingPage from './pages/website/PricingPage';
import ContactPage from './pages/website/ContactPage';

// ── Protected Admin Layout ────────────────────────────────────
function AdminLayout({ children }) {
  const { admin, loading } = useAuth();

  if (loading) {
    return (
      <div style={{
        display: 'flex', alignItems: 'center', justifyContent: 'center',
        minHeight: '100vh', gap: 12, color: '#666'
      }}>
        <div className="spinner" /> Loading...
      </div>
    );
  }

  if (!admin) return <Navigate to="/admin/login" replace />;

  return (
    <div className="admin-layout">
      <Sidebar />
      <main className="main-content">{children}</main>
    </div>
  );
}

// ── App ───────────────────────────────────────────────────────
export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>

          {/* ── Public Website ─────────────────────────────── */}
          <Route path="/"         element={<HomePage />} />
          <Route path="/about"    element={<AboutPage />} />
          <Route path="/pricing"  element={<PricingPage />} />
          <Route path="/contact"  element={<ContactPage />} />

          {/* ── Bulk Orders (coming soon) ───────────────────── */}
          <Route path="/bulk/*" element={
            <div style={{ padding: 40, textAlign: 'center' }}>
              <h2>🏫 Bulk Orders</h2>
              <p style={{ color: '#666', marginTop: 8 }}>Coming soon — currently under development</p>
            </div>
          } />

          {/* ── Admin Panel ────────────────────────────────── */}
          <Route path="/admin/login" element={<Login />} />
          <Route path="/admin" element={
            <AdminLayout><Dashboard /></AdminLayout>
          } />
          <Route path="/admin/orders" element={
            <AdminLayout><Orders /></AdminLayout>
          } />
          <Route path="/admin/users" element={
            <AdminLayout><Users /></AdminLayout>
          } />
          <Route path="/admin/webhooks" element={
            <AdminLayout><WebhookLogs /></AdminLayout>
          } />
          <Route path="/admin/qr-scans" element={
            <AdminLayout><QrScans /></AdminLayout>
          } />
		  <Route path="/admin/pricing" element={
			<AdminLayout><PricingManagement /></AdminLayout>
		  } />

          {/* ── Fallback ───────────────────────────────────── */}
          <Route path="*" element={<Navigate to="/" replace />} />

        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}
